import { render } from "./ColoredButton.vue?vue&type=template&id=71d63256"
import script from "./ColoredButton.vue?vue&type=script&lang=js"
export * from "./ColoredButton.vue?vue&type=script&lang=js"

import "./ColoredButton.vue?vue&type=style&index=0&id=71d63256&lang=scss"

import exportComponent from "/Users/gardener/OpenideProjects/Navigator_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__